module.exports = __webpack_public_path__ + "img/SKMJ_mach4.b29a7139.jpg";